"use client";

import { withFallback } from "../with-fallback";

export const WithdrawButtonElement = withFallback({
	displayName: "WithdrawButtonElement",
	type: "withdraw-button-element",
} as const);
